import { Component } from '@angular/core';
import { IToolPanelAngularComp } from 'ag-grid-angular';
import { IToolPanelParams } from 'ag-grid-community';
import { blank } from '../../utils/common';

@Component({
  selector: 'fieldmagic-data-grid-sidar-menu-tool-panel',
  template: `
    <div class="m-2 mt-4 mb-4 w-100">
      <div fieldmagicGridRow>
        <div fieldmagicGridColumn="12">
          <fieldmagic-text
            content="Configurations"
          >
          </fieldmagic-text>

          <hr class="w-100" />

          <div class="d-flex d-flex-gap flex-column">
            <fieldmagic-primary-button
              label="Reset Columns"
              icon="sync-alt"
              (click)="onResetColumns()"
            >
            </fieldmagic-primary-button>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class FieldmagicDataGridSidebarMenuToolPanelComponent implements IToolPanelAngularComp {
  private _params: IToolPanelParams;

  agInit(params: IToolPanelParams): void {
    this._params = params;
  }

  onResetColumns(): void {
    if (blank(this._params)) {
      return;
    }

    this._params.columnApi.resetColumnState();
  }
}